<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="1200" height="800" :show-footer="true" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" title="赔付分析">
			<template #default>
				<input ref="decodeaddressuploadfile" style="display: none;" type="file" @change="importMethod">
				<el-tag type="danger">上传【xlsx】文件，订单号列表头使用【业务订单号】作为名称，导入后【业务订单号】正常显示才能正常分析</el-tag>
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="primary" @click="importdata">导入</vxe-button>
						<vxe-button @click="exportdata">导出</vxe-button>
						<vxe-button status="danger" @click="analysis" :loading="loading">分析</vxe-button>
					</template>
				</vxe-toolbar>
				<el-divider content-position="center">订单数据</el-divider>
				<el-progress :percentage="progress" style="margin-bottom: 10px;"></el-progress>
				<vxe-grid v-bind="gridOptions" v-if="gridOptions" ref="decodeaddresstable">
				</vxe-grid>
				<exportTable :ref="exportRef" listType="report" />
			</template>

		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import exportTable from '@_system/components/export/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				model: true,
				tableList: [],
				orderinfo: [],
				columns: [],
				gridOptions: null,
				tabledata: [],
				exportRef: 'export_' + Math.random(),
				primarykey: '业务订单号',
				additionalkey: ['业务订单号', '店铺名称', '系统单号', '买家实付', '仓库名称', '快递公司', '下单时间', '付款时间', '打单时间', '发货时间','时间',
					'问题原因','问题类型','判断依据'
				],
				buff: true,
				isfinish: true,
				totalNum: 0,
				progress: 0
			}
		},
		created() {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			getOption() {
				return {
					border: true,
					size: 'mini',
					data: this.tabledata,
					columns: this.columns,
					columnConfig: {
						isHover: false,
						resizable: true
					},
					customConfig: {
						storage: true
					},
					rowConfig: {
						isHover: true,
						isCurrent: true,
					},
					showOverflow: true,
					height: '80%',
					sortConfig: {
						remote: false
					}
				}
			},
			exportdata() {
				let columns = JSON.parse(JSON.stringify(this.columns))
				columns.forEach((item) => {
					item.visible = true
				})
				let obj = {
					data: this.tabledata,
					columns: columns
				}
				this.$refs[this.exportRef].exportData(obj)
			},
			importdata() {
				this.$refs.decodeaddressuploadfile.click()
			},
			importMethod(e) {
				let file = e.target.files[0]
				let reader = new FileReader();
				reader.onload = (e) => {
					let data = e.target.result
					let workbook = this.$XLSX.read(data, {
						type: 'binary'
					})
					let sheetName = workbook.SheetNames[0];
					let worksheet = workbook.Sheets[sheetName]
					let jsonData = this.$XLSX.utils.sheet_to_json(worksheet, {
						defval: null,
						raw: false
					})
					jsonData = jsonData.map(row => {
						let newRow = {};
						for (let key in row) {
							let value = String(row[key]);
							if(value && value!='null'){
								newRow[key] = value.replace(/\t/g, '');
							}
							// 去除制表符
							
						}
						return newRow;
					});
					console.log(jsonData)
					if (jsonData.length != 0) {
						jsonData.forEach((item) => {
							this.additionalkey.forEach((_item) => {
								item[_item] = item[_item] ? item[_item] : null
							})
						})
						let columns = []
						for (let i in jsonData[0]) {
							let obj = {
								field: i,
								title: i,
								visible: false
							}
							if (i == this.primarykey || this.additionalkey.findIndex((col) => {
									return col == i
								}) !== -1) {
								obj.visible = true
							}
							columns.push(obj)
						}

						this.columns = columns
						this.tabledata = jsonData
						this.gridOptions = this.getOption()
						this.importLoading = false
					} else {
						this.importLoading = false
						this.$message.error('暂无数据')
					}
				}
				
				reader.readAsBinaryString(file)


			},
			show() {
				this.progress = 0
				this.buff = true
			},
			hide() {
				this.progress = 0
				this.buff = false
				this.$emit('hide')
			},
			
			analysis() {
				if (this.isfinish) {
					this.loading = true
					this.isfinish = false
					let data = []
					this.tabledata.forEach((item) => {
						let index = data.findIndex((_item) => {
							return _item[this.primarykey] == item[this.primarykey]
						})
						if (!item['问题原因'] && index == -1) {
							data.push(item)
						}
					})
					const tasks = [];
					this.totalNum = data.length
					for (let i = 0; i < data.length; i++) {
						tasks.push(this.createTask(data[i],i))
					}
					// 执行任务
					this.processTasksSequentially(tasks).then(() => {
						this.isfinish = true
						this.loading = false
						console.log('All tasks completed');
					});
				} else {
					this.$message.error('问题分析中')
				}
			},			
			getorder(item,index) {
				let time = parseInt(Math.random() * 1000 + 2000)
				return new Promise((resolve) => {
					setTimeout(() => {
						this.$api.tool.ordercompensation({
							tp_tid: item[this.primarykey],
							finish_time: item['完成时间']
						}).then((res) => {
							console.log(res)
							this.tabledata.forEach((_item) => {
								if (_item[this.primarykey] == item[this.primarykey]) {
									_item['问题原因'] = res.error
									_item['问题类型'] = res.errortype
									_item['判断依据'] = res.errordetail
									_item['店铺名称'] = res.tradeInfo.shop_nick
									_item['系统单号'] = res.tradeInfo.salercpt_no
									_item['买家实付'] = res.tradeInfo.realPayment
									_item['仓库名称'] = res.tradeInfo.storage_name
									_item['快递公司'] = res.tradeInfo.delivery_name
									_item['下单时间'] = window.systemMethods.timestampToDate(res.tradeInfo.trade_create_time)
									_item['付款时间'] = window.systemMethods.timestampToDate(res.tradeInfo.tp_pay_time)
									_item['打单时间'] = window.systemMethods.timestampToDate(res.tradeInfo.print_time)
									_item['发货时间'] = window.systemMethods.timestampToDate(res.tradeInfo.send_goods_time)
								}
							})
							this.progress = parseInt((index+1)/this.totalNum*100)
							resolve()
						})
					}, time)
				})
			},
			
			// 模拟异步任务的函数
			createTask(item,index) {
				return () => this.getorder(item,index).then(() => console.log(item[this.ordercode] + ' finish'));
			},
			
			// 按顺序执行任务的函数
			async processTasksSequentially(tasks) {
				for (const task of tasks) {
					await task();
					if (!this.buff) {
						break
					}
				}
			}
			
			
			
			// analysis() {
			// 	let handle = this.$loading()
			// 	let tp_tid = []
			// 	this.tabledata.forEach((item) => {
			// 		tp_tid.push(item[this.primarykey])
			// 	})
			// 	this.$api.tool.ordercompensation({
			// 		tp_tids: tp_tid
			// 	}).then((res) => {
			// 		this.$loadingclose(handle)
			// 		//['订单编号','店铺名称','系统单号','买家实付','仓库名称','快递公司','下单时间','付款时间','打单时间','发货时间','完成时间','问题原因']
			// 		res.forEach((item) => {
			// 			this.tabledata.forEach((_item) => {
			// 				if (_item[this.primarykey] == item.tp_tid) {
			// 					_item['店铺名称'] = item.shop_nick
			// 					_item['系统单号'] = item.salercpt_no
			// 					_item['买家实付'] = item.realPayment
			// 					_item['仓库名称'] = item.storage_name
			// 					_item['快递公司'] = item.delivery_name
			// 					_item['下单时间'] = window.systemMethods.timestampToDate(item.trade_create_time)
			// 					_item['付款时间'] = window.systemMethods.timestampToDate(item.tp_pay_time)
			// 					_item['打单时间'] = window.systemMethods.timestampToDate(item.print_time)
			// 					_item['发货时间'] = window.systemMethods.timestampToDate(item.send_goods_time)
			// 					_item['问题原因'] = null
			// 				}
			// 			})
			// 		})


			// 		// this.progress = parseInt((index + 1) / this.totalNum * 100)
			// 		// resolve()
			// 	}, () => {
			// 		this.$loadingclose(handle)
			// 	})
			// },
			// analysis(item){
			// 	const timestamp = new Date().getTime();
			// 	item.tp_pay_time
			// }

		},
		components: {
			exportTable
		}
	}
</script>